export function requiredRule(text = 'Item obrigatório') {
  return v => Boolean(v) || text;
}

export function notEmpty(text = 'Item obrigatório') {
  return v => Boolean(v && v.trim()) || text;
}

export function minLength(size, text) {
  return v => (v && v.length >= size) || (text || `Selecione ao menos ${size} item(s)`);
}

export function maxLength(size, text) {
  return v => (v && v.length <= size) || (text || `Selecione no máximo ${size} item(s)`);
}

export function validateEmail(text = 'Email inválido') {
  return email => /.+@.+\.+.+/u.test(email) || text;
}
